import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m7.609 6.108 12.615 4.246c1.323.385 2.293 1.723 2.293 3.277v14.061L20.716 29V13.63a2.044 2.044 0 0 0-1.308-1.8L5.963 7.416l1.646-1.307Zm-1.646 4.077 1.8.661v10.462c.03.846.538 1.584 1.307 1.8l8.846 2.938v1.8L8.24 24.738c-1.324-.523-2.293-1.846-2.293-3.276V10.185h.016ZM11.87 3l12.954 4.246a3.527 3.527 0 0 1 2.292 3.277v13.739l-1.8 1.307V10.677c-.03-.846-.538-1.585-1.307-1.8l-13.77-4.585L11.87 3Zm-.338 8.985 1.8.661v5.077c.03.83.523 1.57 1.308 1.8l3.276 1.139v1.8l-4.092-1.308c-1.338-.539-2.292-1.877-2.292-3.277v-5.892Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }